var map = {
	"./about-us/about-us.module": [
		"./src/app/admin/components/dashboard/about-us/about-us.module.ts",
		"default~about-us-about-us-module~clients-clients-module~contacts-contacts-module~projects-projects-m~b60f3502",
		"default~about-us-about-us-module~services-services-module",
		"about-us-about-us-module"
	],
	"./admin/components/dashboard/dashboard.module": [
		"./src/app/admin/components/dashboard/dashboard.module.ts",
		"admin-components-dashboard-dashboard-module"
	],
	"./clients/clients.module": [
		"./src/app/admin/components/dashboard/clients/clients.module.ts",
		"default~about-us-about-us-module~clients-clients-module~contacts-contacts-module~projects-projects-m~b60f3502",
		"clients-clients-module"
	],
	"./contacts/contacts.module": [
		"./src/app/admin/components/dashboard/contacts/contacts.module.ts",
		"default~about-us-about-us-module~clients-clients-module~contacts-contacts-module~projects-projects-m~b60f3502",
		"contacts-contacts-module"
	],
	"./projects/projects.module": [
		"./src/app/admin/components/dashboard/projects/projects.module.ts",
		"default~about-us-about-us-module~clients-clients-module~contacts-contacts-module~projects-projects-m~b60f3502",
		"projects-projects-module"
	],
	"./services/services.module": [
		"./src/app/admin/components/dashboard/services/services.module.ts",
		"default~about-us-about-us-module~clients-clients-module~contacts-contacts-module~projects-projects-m~b60f3502",
		"default~about-us-about-us-module~services-services-module",
		"services-services-module"
	],
	"./users/users.module": [
		"./src/app/admin/components/dashboard/users/users.module.ts",
		"default~about-us-about-us-module~clients-clients-module~contacts-contacts-module~projects-projects-m~b60f3502",
		"users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;